<template>
  <el-dialog :title="form.id?'编辑部门':'添加部门'" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-form ref="dataForm" label-position="right"  :rules="formRules" :model="form" size="small" label-width="130px">
      <el-form-item label="部门名称：" prop="deptName" class="width100">
          <el-input v-model="form.deptName" placeholder="请输入部门名称" />
      </el-form-item>
      <el-form-item label="权限：" prop="authority" class="width100">
        <el-select v-model="form.authority" placeholder="请选择权限" multiple>
          <el-option label="商城价格查看权限" :value="1"></el-option>
          <el-option label="学习权限" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：" prop="deptStatus" required>
        <el-switch v-model="form.deptStatus" :active-value="1" :inactive-value="0">
        </el-switch>
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import sysDeptApi from '@/api/sys/sysDept'
  function initFormBean() {
    const formBean = {
      deptName:null,
      authority:null,
      deptStatus:1
    }
    return formBean
  }

  export default {
    data() {
      return {
        form: initFormBean(),
        technicalLine:'', //技术线
        formVisible: false,
        formRules: {
          deptName: [{
            required: true,
            message: '请输入部门名称',
            trigger: 'blur'
          }],
        },
      }
    },
    created() {

    },
    methods: {
      resetForm() {
        this.form = initFormBean()
      },
      handleCreate() {
        this.resetForm()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      handleUpdate(row) {
        console.log('row: ',row);
        this.resetForm()
        this.form = {
          ...row
        }
        this.form.authority=[]
        if(row.canLookGoodsPrice){
          this.form.authority.push(1)
        }
        if(row.canStudyCourse){
          this.form.authority.push(2)
        }
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      doCreate() {
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            let params={...this.form}
            params.canLookGoodsPrice=this.form.authority.findIndex(i=>i==1)==-1?0:1
            params.canStudyCourse=this.form.authority.findIndex(i=>i==2)==-1?0:1
            delete params.authority
            console.log('params: ',params);
            if(this.form.id){
              sysDeptApi.update(params).then((data) => {
                this.postCallback(data)
              });
            }else{
              sysDeptApi.create(params).then((data) => {
                this.postCallback(data)
              });
            }

          }
        });
      },
      postCallback(data) {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
      },
    }
  }
</script>
<style lang="scss" scoped>
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-cascader{
    width: 100%;
  }
  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }
  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }
  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }
</style>
